import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class GtmAnalyticsService {
  private loaded = false;
  private readonly gtmContainerId = environment.gtmContainerId;

  loadAnalytics(): void {
    if (this.loaded || !this.gtmContainerId) {
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${this.gtmContainerId}`;
    document.head.appendChild(script);

    const noscript = document.createElement("noscript");
    noscript.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=${this.gtmContainerId}" height="0" width="0"
            style="display:none;visibility:hidden"></iframe>
    `;
    document.body.appendChild(noscript);

    this.loaded = true;
  }
}
